import {isEmpty} from "../common/tool";

const checkValue = function (rules, value) {
    let tip = null;
    if(rules) {
        rules.every(rule => {
            let msg = rule.message;
            for(let key in rule) {
                if(key == "message") return true;
                let rv = rule[key];
                if(key == 'require') {
                    if(rv && isEmpty(value)) {
                        tip = msg;
                        return false;
                    }
                } else if(key == 'min' || key == 'max') {
                    let l;
                    if(Object.prototype.toString.call(value) === 'object Array') {
                        l = value.length;
                    } else {
                        l = isNaN(value * 1) ? value.length : value * 1;
                    }
                    if((key == 'min' && l < rv) || (key == 'max' && l > rv)) {
                        tip = msg;
                        return false;
                    }
                } else if(key == 'regex') {
                    let regexp = new RegExp(rv);
                    if(!regexp.test(value)) {
                        tip = msg;
                        return false;
                    }
                } else {
                    return true;
                }
            }
        });
    }
    return tip;
}

export {checkValue}
